import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { CreatePetitionUpdateInput, CreatePetitionUpdateResponse } from '../types';

import type {
	StarterDashboardV2CreateStarterPetitionUpdateMutation,
	StarterDashboardV2CreateStarterPetitionUpdateMutationVariables,
} from './createPetitionUpdate.graphql';
import { StarterDashboardV2CreateStarterPetitionUpdate } from './createPetitionUpdate.graphql';

export async function createPetitionUpdate(
	input: CreatePetitionUpdateInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<CreatePetitionUpdateResponse> {
	const { data, errors } = await fetch<
		StarterDashboardV2CreateStarterPetitionUpdateMutation,
		StarterDashboardV2CreateStarterPetitionUpdateMutationVariables
	>({
		query: StarterDashboardV2CreateStarterPetitionUpdate,
		variables: {
			input,
		},
		rejectOnError: false,
	});

	if (errors) throw new Error(JSON.stringify(errors));
	if (!data) throw new Error('Empty data in createPetitionUpdate graphQL response');

	return data.createPetitionUpdate;
}
